// api/teachers.js

import axios from 'axios';
import { backendHOST } from '../client-config/client-config';
import setAuthToken from '../utils/setAuthToken';

const url = `${backendHOST}/api/scriptantiaAdmin/Teacher`;

function ensureAuthToken() {
  if (localStorage.token) {
    setAuthToken(localStorage.token);
    return true;
  }

  return false;
}

export async function getTeachers() {
  if (!ensureAuthToken()) return [];

  try {
    const res = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return Array.isArray(res.data) ? res.data : [];
  } catch (error) {
    console.error('Oktatók betöltési hiba:', error);
    return [];
  }
}
